import {Controller} from "@hotwired/stimulus"

import {
  flip,
  shift,
  arrow,
  offset,
  computePosition
} from "@floating-ui/dom"

class TooltipController extends Controller {
  static targets = ["button", "tooltip", "arrow"]
  static values = {
    placement: String,
    isOpen: Boolean
  }

  connect() {
    if (!this.isOpenValue) return

    this.show()
    setTimeout(() => {
      this.hide()
    }, 1000)
  }

  show() {
    if (!this.hasTooltipTarget) return

    // on mobile the mouseenter event and the click event
    // can be triggered at the same time
    this.show_was_triggered = true
    setTimeout(() => {
      this.show_was_triggered = false
    }, 50)

    this.tooltipTarget.style.display = "block"
    const placement = this.placementValue || "top"

    computePosition(this.buttonTarget, this.tooltipTarget, {
      placement,
      middleware: [
        flip({padding: 5}),
        shift({padding: 5}),
        offset(7),
        arrow({element: this.arrowTarget})
      ]
    }).then(({x, y, middlewareData, placement}) => {
      Object.assign(this.tooltipTarget.style, {
        left: `${x}px`, top: `${y}px`
      })
      const {x: arrowX, y: arrowY} = middlewareData.arrow
      const static_side = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[placement.split("-")[0]]

      Object.assign(this.arrowTarget.style, {
        left: arrowX != null ? `${arrowX}px` : "",
        top: arrowY != null ? `${arrowY}px` : "",
        right: "",
        bottom: "",
        [static_side]: "-4px"
      })
    })
  }

  hide() {
    if (!this.hasTooltipTarget) return

    this.tooltipTarget.style.display = "none"
  }

  toggle() {
    if (!this.hasTooltipTarget) return
    // on mobile the mouseenter event and the click event
    // can be triggered at the same time
    if (this.show_was_triggered) return

    if (this.tooltipTarget.style.display !== "block") {
      this.show()
    } else {
      this.hide()
    }
  }
}

export default TooltipController
